module.exports = __webpack_public_path__ + "img/preview.fc57673e.jpg";